import { render, staticRenderFns } from "./turbine-list.vue?vue&type=template&id=28857b88&scoped=true"
import script from "./turbine-list.vue?vue&type=script&lang=js"
export * from "./turbine-list.vue?vue&type=script&lang=js"
import style0 from "./turbine-list.vue?vue&type=style&index=0&id=28857b88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28857b88",
  null
  
)

export default component.exports